import { Injectable } from '@angular/core';
import {
  BaseService,
  HttpClient,
  HttpHeaders,
  HttpParams,
} from './base.service';
import { IShiftHistory } from '../shared/api';
import { AccountService } from './account.service';

@Injectable()
export class ShiftHistoryService extends BaseService<IShiftHistory> {
  constructor(accountService: AccountService, http: HttpClient) {
    super(accountService, http, 'shiftHistory');
  }
}

export { IShiftHistory } from '../shared/api';
